import { SSO_AUTH_SERVICE_URL } from 'api';
import { apiService, useHandleError } from 'framework/api';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';

export const useAuthenticationApi = () => {
  const { getToken } = useAuthenticationProvider();
  const errorHandler = useHandleError();

  return apiService(SSO_AUTH_SERVICE_URL ?? '', {
    errorHandler,
    authProvider: {
      getAuthHeader: async () => ({
        name: 'Authorization',
        value: `Bearer ${getToken()}`,
      }),
    },
    unauthenticatedRequestHandler: null,
  });
};
